module.exports = __webpack_public_path__ + "static/media/ic_icon.1456322e.png";